<app-pos-profile-form-wrapper
  data-testid="pos-profile-view-form-wrapper"
  [config]="config"
  [editMode]="false"
  [viewMode]="true"
></app-pos-profile-form-wrapper>
